import {
  CREATED_BY_VALUES,
  RESET_WIZARD,
  TOGGLE_LANDING_PAGE,
} from 'containers/AwarenessCenter/WizardCampaign/steps/constants'

import {
  CHANGE_CREATED_BY_FILTER,
  CHANGE_SORT_BY,
  CHANGE_TYPE_FILTER,
  FETCH_LANDING_PAGES_ASYNC,
  SET_IS_VISITED,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    error: null,
    data: {
      landingPages: [],
    },
    defaultOnceApplied: false,
    createdByFilter: CREATED_BY_VALUES.ALL_TYPES,
    typeFilter: 0,
    sortByUsage: false,
    isVisited: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case TOGGLE_LANDING_PAGE:
        return {
          ...state,
          defaultOnceApplied: true,
        }
      case RESET_WIZARD:
        return {
          ...initialState,
        }
      case CHANGE_CREATED_BY_FILTER:
        return {
          ...state,
          loader: true,
          createdByFilter: action.payload.value,
        }
      case CHANGE_TYPE_FILTER:
        return {
          ...state,
          loader: true,
          typeFilter: action.payload.value,
        }
      case CHANGE_SORT_BY:
        return {
          ...state,
          loader: true,
          sortByUsage: action.payload.value,
        }
      case FETCH_LANDING_PAGES_ASYNC.INITIATE:
        return {
          ...state,
          loader: true,
          error: null,
        }
      case FETCH_LANDING_PAGES_ASYNC.SUCCESS:
        return {
          ...state,
          loader: false,
          data: {
            ...state.data,
            landingPages: action.payload.data,
          },
        }
      case FETCH_LANDING_PAGES_ASYNC.ERROR:
      case FETCH_LANDING_PAGES_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
        }
      case SET_IS_VISITED: {
        return {
          ...state,
          isVisited: action.payload.value,
        }
      }
      default:
        return state
    }
  }
}
